export const TOGGLE_SELECT_CLAUSE = "PREVIOUS-VERSIONS:TOGGLE_SELECT_CLAUSE";
export const SELECT_CLAUSE = "PREVIOUS-VERSIONS:SELECT_CLAUSE";
export const DESELECT_CLAUSE = "PREVIOUS-VERSIONS:DESELECT_CLAUSE";
